export default class InsuredToSave {
  /** (String): El nombre del asegurado. */
  name!: string

  /** (String): El primer apellido del asegurado. */
  firstSurname!: string

  /** (String): El segundo apellido del asegurado. */
  secondSurname!: string

  /** (String): El tipo de documento de identidad del asegurado. */
  documentType!: string

  /** (String): El número de documento de identidad del asegurado. */
  documentNumber!: string

  personType!: string

  /** (String): La fecha de expiracion del document de identidad del asegurado. */
  documentExpirationDate?: string

  /** (String): La nacionalidad del asegurado. */
  nacionality!: string
  nationality!: string

  /** (DateTime): La fecha de nacimiento del asegurado. */
  birthDate?: string

  /** (String): El sexo del asegurado. */
  sex!: string

  /** (Integer): El número de riesgo asociado al asegurado. */
  riskNumber!: number

  /** (String): La dirección de correo electrónico del asegurado. */
  email!: string

  /** (String): El prefijo telefónico del asegurado. */
  prefix!: string

  /** (String): El número de teléfono móvil del asegurado. */
  mobilePhone!: string

  /** (String): El código postal de la dirección del asegurado. */
  postalCode!: string

  /** (String): La provincia de la dirección del asegurado. */
  province!: string

  /** (String): La ciudad de la dirección del asegurado. */
  city!: string

  /** (String): El tipo de calle de la dirección del asegurado. */
  streetType!: string

  /** (String): El nombre de la calle de la dirección del asegurado. */
  street!: string

  /** (Integer): El tipo de vivienda del asegurado.
   * 1 -> piso
   * 2 -> casa
   */
  houseType!: string

  /** (String): El número de vivienda del asegurado. */
  house!: string

  /** (String): El portal de la dirección del asegurado. */
  gateway!: string

  /** (String): La escalera de la dirección del asegurado. */
  stair!: string

  /** (String): El piso de la dirección del asegurado. */
  floor!: string

  /** (String): La puerta de la dirección del asegurado. */
  doorway!: string

  /** (String): El resto de la dirección del asegurado. */
  restAddress!: string

  /** (Boolean): Indica si el asegurado tiene una póliza de la rama de salud. */
  hasHealthPolicy!: boolean

  /** (String): Indica el parentesco con el tomador. */
  relationship!: string

  student?: string

  policyHolderConsent!: boolean

  healthPolicyNumber!: string // TODO - remove from here

  addressNormalice?: boolean | null

  hasPolicyInOtherCompany?: boolean

  constructor(data: any) {
    this.name = data.name
    this.firstSurname = data.firstSurname
    this.secondSurname = data.secondSurname
    this.documentType = data.documentType
    this.documentNumber = data.documentNumber
    this.personType = data.personType
    this.documentExpirationDate = data.documentExpirationDate
    this.nacionality = data.nacionality
    this.nationality = data.nationality
    this.birthDate = data.birthDate
    this.sex = data.sex
    this.riskNumber = data.riskNumber
    this.email = data.email
    this.prefix = data.prefix
    this.mobilePhone = data.mobilePhone
    this.postalCode = data.postalCode
    this.province = data.province
    this.city = data.city
    this.streetType = data.streetType
    this.street = data.street
    this.houseType = data.houseType
    this.house = data.house
    this.gateway = data.gateway
    this.stair = data.stair
    this.floor = data.floor
    this.doorway = data.doorway
    this.restAddress = data.restAddress
    this.hasHealthPolicy = data.hasHealthPolicy
    this.relationship = data.relationship
    this.policyHolderConsent = data.policyHolderConsent ?? true
    this.healthPolicyNumber = data.healthPolicyNumber
    this.addressNormalice = data.addressNormalice ?? undefined
    this.hasPolicyInOtherCompany = data.hasPolicyInOtherCompany
    this.student = data.student
  }
}
